import BudgetComponentListAlert from 'components/Alert/BudgetComponentList';
import BudgetExportSuccessAlert from 'components/Alert/BudgetExportSuccess';
import DangerDeleteAlert from 'components/Alert/DangerDelete';
import GenericAlert from 'components/Alert/Generic';

export default {
  genericAlert: GenericAlert,
  dangerDeleteAlert: DangerDeleteAlert,
  budgetExportSuccess: BudgetExportSuccessAlert,
  budgetComponentListAlert: BudgetComponentListAlert,
};
